import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import languageContract from "../../../shared/supported-languages.json";

const { sourceLanguage, supportedLanguages } = languageContract;

void i18n
  .use(HttpBackend) // Loads translations from /public/locales
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: sourceLanguage,
    nonExplicitSupportedLngs: true, // Resolve de-DE/de-AT to de instead of raw fallback
    load: "languageOnly", // Do not request unsupported regional locale files
    debug: process.env.NODE_ENV === "development", // Enable debug mode in development
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Path to translation files
    },
    // react-i18next options
    react: {
      useSuspense: false, // Set to true if you want to use Suspense for loading translations
    },
  });

export default i18n;
